import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { BusinessCard } from "@/components/Cards";
import { TID } from "@/constants/testIds";
import { Search } from "lucide-react";

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "restaurants", label: "Restaurants" },
  { key: "cafes", label: "Cafes" },
  { key: "bars", label: "Bars" },
  { key: "attractions", label: "Attractions" },
  { key: "wellness", label: "Wellness" },
  { key: "fitness", label: "Fitness" },
];

export default function Directory() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState(params.get("cat") || "all");
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/businesses", { params: { category: cat, q: q || undefined } })
      .then((r) => setItems(r.data));
  }, [cat, q]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-24">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <span className="editorial-divider" />
        <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Directory.</h1>
        <p className="text-lg text-[color:var(--forest-2)] mt-4 max-w-2xl">
          Restaurants, cafes, bars, attractions and wellness — curated by the Hey GC editors, vetted by locals.
        </p>
      </motion.div>

      <div className="mt-10 flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex items-center gap-2 bg-white border border-[color:var(--forest-line)] rounded-full pl-5 py-2 pr-2 max-w-xl w-full md:w-auto md:flex-1">
          <Search size={16} className="opacity-60" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search restaurants, suburbs, cuisines…"
            className="flex-1 bg-transparent outline-none py-2 text-sm"
          />
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {CATEGORIES.map((c) => (
          <button
            key={c.key}
            data-testid={TID.bizCategoryFilter(c.key)}
            onClick={() => { setCat(c.key); setParams({ cat: c.key }); }}
            className={`chip ${cat === c.key ? "chip-active" : ""}`}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {items.map((b, i) => <BusinessCard key={b.id} biz={b} index={i} />)}
      </div>
    </div>
  );
}
